module.exports = __webpack_public_path__ + "img/github-2.8c0f0832.jpg";